import React, { useEffect, useState } from "react";
import Notiflix from "notiflix";
import {
  url_path_images,
  getStaffLogin,
  loadingScreen,
  socketServer,
} from "../helper";
import { useNavigate } from "react-router-dom";
import { CgProfile } from "react-icons/cg";

export default function NavBar() {
  const navigate = useNavigate();
  const userData = getStaffLogin();
  const [isMini, setIsMini] = useState(
    localStorage.getItem("SIDEBAR_MINI") === "true"
  );

  // Sync with sidebar toggle event
  useEffect(() => {
    const handler = (e) => setIsMini(e.detail.isMini);
    window.addEventListener("sidebar-toggle", handler);
    return () => window.removeEventListener("sidebar-toggle", handler);
  }, []);

  const _onLogout = async () => {
    Notiflix.Confirm.show(
      "ຢຶນຢັນ",
      "ທ່ານຕ້ອງການອອກຈາກລະບົບແທ້ຫຼື ບໍ່?",
      "ຕົກລົງ",
      "ຍົກເລີກ",
      async function () {
        localStorage.clear();
        sessionStorage.clear();
        loadingScreen();
        setTimeout(() => {
          Notiflix.Loading.remove();
          window.location.replace("/login");
        }, 1500);
      },
      function () { }
    );
  };
  const isMobile = window.innerWidth <= 1199.98;

  const leftWidth = isMobile
    ? (isMini ? 0 : 180)
    : (isMini ? 60 : 240);

  return (
    <nav
      className="nav navbar navbar-expand-xl iq-navbar sticky-top"
      style={{
        position: "fixed",
        top: 0,
        right: 0,
        left: leftWidth,
        backgroundColor: "#e50401",
        transition: "left 0.4s ease",
      }}
    >
      <div className="container-fluid navbar-inner text-center flex-nowrap">
        <a onClick={() => navigate("/home")} className="navbar-brand">
          {/*Logo start*/}
          <div className="logo-main text-center">
            <div className="logo-normal text-white d-flex align-items-center justify-content-center gap-2">
              {userData?.profileImagePath ? (
                <img
                  src={url_path_images + userData?.profileImagePath}
                  className="img-fluid"
                  alt=""
                  style={{
                    maxHeight: 50,
                    BorderRadius: "30% 70% 54% 46% / 30% 53% 47% 70%",
                  }}
                />
              ) : (
                <div style={{ width: 50, height: 50 }} className="d-flex justify-content-center align-items-center" >
                  <CgProfile size={40} />
                </div>
              )}
              <span className="fs-5">{userData?.firstName}</span>
            </div>
            <div className="logo-mini text-white">
              <img
                src={url_path_images + userData?.profileImagePath}
                className="img-fluid"
                alt=""
                style={{
                  maxHeight: 50,
                  BorderRadius: "30% 70% 54% 46% / 30% 53% 47% 70%",
                }}
              />
              <span className="fs-5">{userData?.firstName}</span>
            </div>
          </div>
        </a>

        <div
          hidden={isMini ? false : true}
          className="sidebar-toggle"
          data-toggle="sidebar"
          data-active="true"
          onClick={() => {
            const current = localStorage.getItem("SIDEBAR_MINI") === "true";
            const next = !current;
            localStorage.setItem("SIDEBAR_MINI", next ? "true" : "false");
            window.dispatchEvent(
              new CustomEvent("sidebar-toggle", { detail: { isMini: next } })
            );
          }}
          style={{ cursor: "pointer" }}
        >
          <i className="icon d-flex">
            <svg className="icon-20" width={20} viewBox="0 0 24 24">
              <path
                fill="currentColor"
                d="M4,11V13H16L10.5,18.5L11.92,19.92L19.84,12L11.92,4.08L10.5,5.5L16,11H4Z"
              />
            </svg>
          </i>
        </div>

        <div className="navbar" id="navbarSupportedContent">
          <ul className="mb-2 navbar-nav ms-auto align-items-center mb-lg-0">
            <li className="nav-item">
              <a
                className="py-0 nav-link d-flex align-items-center"
                href="#"
                role="button"
                onClick={_onLogout}
              >
                <div className="btn btn-primary btn-icon btn-sm rounded-pill hvr-pulse">
                  <span className="btn-inner">
                    <i className="icon-log-out" />
                  </span>
                </div>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
}
